import { createBrowserHistory, createMemoryHistory } from "history";

const history = createBrowserHistory();
const memoryHistory = createMemoryHistory();
export { memoryHistory };
export default history;
